import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import countryCodes from "../data/countrycodes.json";

const customStyles = {
	control: (provided, state) => ({
		...provided,
		minHeight: "55px",
		borderColor: "#9cc54b",
		boxShadow: state.isFocused ? "0 0 0 1px #9cc54b" : "none",
		zIndex: 999999,
		"&:hover": {
			border: "2px solid #9cc54b",
		},
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 999999,
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#9cc54b" : null,
		color: state.isSelected ? "#fff" : "#333",
		zIndex: 999999,
		"&:hover": {
			backgroundColor: "#9cc54b",
			color: "#fff",
		},
	}),
};

const CountryCodeSelect = ({
	                           value,
	                           onChange,
	                           placeholder = "Select Code",
	                           error,
	                           name = "countryCode",
                           }) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		const formatted = countryCodes.map((country) => ({
			value: country.dial_code,
			label: `${country.name} (+${country.dial_code})`,
		}));
		setOptions(formatted);
	}, []);

	return (
		<div>
			<Select
				value={options.find((opt) => opt?.value === value)}
				onChange={(selectedOption) => onChange(selectedOption, name)}
				placeholder={placeholder}
				options={options}
				classNamePrefix="select"
				styles={customStyles}
				inputProps={{autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off'}}
			/>
			{error && <div style={{color: "red", marginTop: 4}}>{error}</div>}
		</div>
	);
};

CountryCodeSelect.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	error: PropTypes.bool,
	name: PropTypes.string,
};

export default CountryCodeSelect;
